import axiosInstanceNode, { LONG_REQUEST_TIMEOUT_MS } from "@/api/axiosInstanceNode";

/** Generate relationship mapping for a single contact (POST). */
export const fetchRelationshipMappingApi = async ({
  companyName = "",
  searchQuery = "",
  forceRefresh = false,
}) => {
  const params = new URLSearchParams();
  params.set("companyName", companyName);
  if (searchQuery) params.set("search", searchQuery);
  if (forceRefresh) params.set("forceRefresh", "true");

  const { data } = await axiosInstanceNode.get(
    `/accounts/contactList?${params.toString()}`,
    { timeout: LONG_REQUEST_TIMEOUT_MS },
  );
  return data;
};

/** Full prospect profile for one mapping row (GET). */
export const fetchRelationshipMappingDetailApi = async ({
  relationshipMappingId = "",
  forceRefresh = false,
}) => {
  const params = new URLSearchParams();
  if (forceRefresh) params.set("forceRefresh", "true");
  const queryString = params.toString();

  const { data } = await axiosInstanceNode.get(
    `/accounts/contactDetail/${relationshipMappingId}${queryString ? `?${queryString}` : ""}`,
  );
  return data;
};

// update relationship type
export const updateRelationshipTypeApi = async ({
  relationshipMappingId = "",
  relationshipType = "",
}) => {
  const { data } = await axiosInstanceNode.patch(
    `/accounts/contactDetail/${relationshipMappingId}/relationship`,
    { relationship: relationshipType },
  );
  return data;
};

export const saveRelationshipContactDetailsApi = async ({
  relationshipMappingId,
  email,
  whatsappNumber,
}) => {
  const payload = {
    ...(email !== undefined ? { email } : {}),
    ...(whatsappNumber !== undefined ? { whatsappNumber } : {}),
  };
  const { data } = await axiosInstanceNode.patch(
    `/accounts/contactDetail/${relationshipMappingId}/contact-details`,
    payload,
  );
  return data;
};

export const findRelationshipEmailApi = async ({ relationshipMappingId }) => {
  const { data } = await axiosInstanceNode.post(
    `/accounts/contactDetail/${relationshipMappingId}/email/find`,
    {},
  );
  return data;
};

export const draftRelationshipEmailApi = async ({ relationshipMappingId }) => {
  const { data } = await axiosInstanceNode.post(
    `/accounts/contactDetail/${relationshipMappingId}/email/draft`,
    {},
    { timeout: LONG_REQUEST_TIMEOUT_MS },
  );
  return data;
};

export const sendRelationshipEmailApi = async ({
  relationshipMappingId,
  requestId,
  subject,
  body,
  cc,
}) => {
  const { data } = await axiosInstanceNode.post(
    `/accounts/contactDetail/${relationshipMappingId}/email/send`,
    { requestId, subject, body, cc },
  );
  return data;
};

export const sendAccountEmailApi = async ({
  companyName,
  recipient,
  requestId,
  subject,
  body,
  cc,
}) => {
  const { data } = await axiosInstanceNode.post("/accounts/accountEmail/send", {
    companyName,
    recipient,
    requestId,
    subject,
    body,
    cc,
  });
  return data;
};

// get reationship recorded notes
export const getRelationshipRecordedNotesApi = async ({
  relationshipMappingId = "",
}) => {
  const { data } = await axiosInstanceNode.get(
    `/accounts/contactDetail/${relationshipMappingId}/notes`,
  );
  return data;
};

// add relationship recorded note
export const addRelationshipRecordedNoteApi = async ({
  relationshipMappingId = "",
  note,
}) => {
  const { data } = await axiosInstanceNode.post(
    `/accounts/contactDetail/${relationshipMappingId}/notes`,
    note,
  );
  return data;
};

// update relationship recorded note
export const updateRelationshipRecordedNoteApi = async ({
  noteId = "",
  note,
}) => {
  const { data } = await axiosInstanceNode.put(
    `/accounts/notes/${noteId}`,
    note,
  );
  return data;
};

// delete relationship recorded note
export const deleteRelationshipRecordedNoteApi = async ({ noteId = "" }) => {
  const { data } = await axiosInstanceNode.delete(
    `/accounts/notes/${noteId}`,
  );
  return data;
};



/** Follow up reminder */
export const fetchFollowUpReminderApi = async ({
  relationshipMappingId = "",
}) => {
  const { data } = await axiosInstanceNode.get(
    `/accounts/contactDetail/${relationshipMappingId}/followUps`,
  );
  return data;
};


// add follow up reminder
export const addFollowUpReminderApi = async ({
  relationshipMappingId = "",
  followUpReminder,
}) => {
  const { data } = await axiosInstanceNode.post(
    `/accounts/contactDetail/${relationshipMappingId}/followUps`,
    followUpReminder,
  );
  return data;
};

// update follow up reminder
export const updateFollowUpReminderApi = async ({
  followUpId = "",
  followUpReminder,
}) => {
  const { data } = await axiosInstanceNode.patch(
    `/accounts/followUps/${followUpId}`,
    followUpReminder,
  );
  return data;
};

// delete follow up reminder
export const deleteFollowUpReminderApi = async ({ followUpId = "" }) => {
  const { data } = await axiosInstanceNode.delete(
    `/accounts/followUps/${followUpId}`,
  );
  return data;
};

/** Move relationship contact to campaign */
export const moveContactToCampaignApi = async (payload) => {
  const { data } = await axiosInstanceNode.post("/accounts/moveToCampaign", payload);
  return data;
};
